import { useCallback } from 'react'

import { useQueryClient } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'

import { registerNewReport } from 'actions/ui/app'

import { invalidateReportsDownloadsQueries } from './invalidateReportsDownloadsQueries'
import {
    type NotifyAsyncExportStartedOptions,
    reportFromExportData,
} from './reportFromExportData'
import { showAsyncExportToast } from './showAsyncExportToast'

export type { NotifyAsyncExportStartedOptions } from './reportFromExportData'

export function useNotifyAsyncExportStarted(): (
    options: NotifyAsyncExportStartedOptions
) => void {
    const queryClient = useQueryClient()
    const dispatch = useDispatch()

    return useCallback(
        ({
            reportName,
            report: reportData,
        }: NotifyAsyncExportStartedOptions) => {
            void invalidateReportsDownloadsQueries(queryClient)

            const report = reportFromExportData(reportData)
            if (report) {
                dispatch(registerNewReport(report))
            }

            showAsyncExportToast(reportName)
        },
        [dispatch, queryClient]
    )
}
